import styled from '@emotion/styled';

import { COLORS3, FONT } from '../styles/emotion';

export type ParagraphColor = 'BLACK_100' | 'BLACK_075' | 'BLACK_050' | 'WHITE_100';
export type ParagraphSize = 'large' | 'base' | 'small';

export const Paragraph = styled('p', {
  shouldForwardProp: (prop) => !['color', 'as'].includes(prop),
})<{
  size?: ParagraphSize;
  color: ParagraphColor;
}>`
  margin: 0;
  padding: 0;

  ${({ size }) => {
    switch (size) {
      case 'large':
        return FONT.textSizeCompact(FONT.SIZE.REGULAR);
      case 'small':
        return FONT.textSizeCompact(FONT.SIZE.SMALLER);
      case 'base':
      default:
        return FONT.textSizeCompact(FONT.SIZE.SMALL);
    }
  }}

  ${({ color }) => `color: ${COLORS3[color as keyof typeof COLORS3]};`}
`;
